import React from 'react'
import { useDrop } from 'react-dnd'
import { useFormContext } from 'react-hook-form'
import { Box } from '@mui/material_modern'
import CustomCheckTemplateItem from 'components/layouts/settings/components/CustomCheckTemplateItem'
import { CUSTOM_CHECK_TEMPLATE_FIELDS } from 'utils/constants'
import { roundTo } from 'utils/data-manipulation/valueFormatter'

const CustomCheckTemplateContainer = () => {
  const { setValue, watch } = useFormContext()
  const watchCheckLayout = watch('purchaseSettings.payment.checkLayout')

  const moveItem = (id, x, textAlignment, top) => {
    setValue(
      'purchaseSettings.payment.checkLayout',
      {
        ...watchCheckLayout,
        [id]: {
          [textAlignment]: x,
          top,
        },
      },
      {
        shouldDirty: true,
      },
    )
  }
  const [, drop] = useDrop(
    () => ({
      accept: 'field',
      drop: (field, monitor) => {
        const delta = monitor.getDifferenceFromInitialOffset()
        const textAlignmentMultiplier = field.textAlignment === 'left' ? 1 : -1
        const x = roundTo(field.x + delta.x * textAlignmentMultiplier)
        const top = roundTo(field.top + delta.y)
        moveItem(field.id, x, field.textAlignment, top)
        return undefined
      },
    }),
    [moveItem],
  )

  return (
    <Box
      ref={drop}
      sx={{
        width: 816, // TODO: allow users to change check width
        height: 300, // TODO: allow users to change check height
        border: '1px solid black',
        position: 'relative',
        backgroundColor: 'background.section',
      }}
    >
      {CUSTOM_CHECK_TEMPLATE_FIELDS.map(fieldData => {
        const { id, textAlignment, title } = fieldData
        const { left, right, top } = watchCheckLayout?.[id] || {}
        return (
          <CustomCheckTemplateItem
            key={id}
            id={id}
            textAlignment={textAlignment}
            x={textAlignment === 'left' ? left : right}
            top={top}
          >
            {title}
          </CustomCheckTemplateItem>
        )
      })}
    </Box>
  )
}

export default CustomCheckTemplateContainer
